export default __webpack_public_path__ + "static/media/keyboard.7a42273a.png";